module.exports = __webpack_public_path__ + "media/jp.95c2abfe.svg";